require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/core-js/library/fn/object/set-prototype-of.js
// module id = 1254
// module chunks = 3